import {
  getDynHistorischBesluit,
  getDynHistorischBesluitId,
  getDynMetaVoorschriftHistorischBesluit,
} from '@/api/generated/digiVAPI';
import { createQuery } from '@/utils/tanstack-query/createQuery';
import { createInfiniteQuery } from '@/utils/tanstack-query/createQuery/createInifiniteQuery';

export const useHistorischBesluit = createQuery({
  key: ['historischBesluit'],
  queryFn: getDynHistorischBesluit,
});

export const useHistorischBesluitId = createQuery({
  key: ['historischBesluitId'],
  queryFn: getDynHistorischBesluitId,
});

export const useHistorischBesluitLink = createQuery({
  key: ['historischBesluitLink'],
  queryFn: getDynMetaVoorschriftHistorischBesluit,
});

export const useHistorischBesluitLinkInfinite = createInfiniteQuery({
  key: ['historischBesluitLink', 'infinite'],
  queryFn: getDynMetaVoorschriftHistorischBesluit,
});
